/**
 * Constants for NetPPM workflow step IDs
 */
export const NETPPM_STEP_IDS = {
  GENERATE_PRUNED_VARIANCE_TREE: 'step_netppm_generate_pruned_variance_tree',
  USER_TREE_SELECTION: 'step_netppm_user_tree_selection',
  GENERATE_COMMENTARY: 'step_netppm_generate_commentary',
} as const;

export type NetPPMStepId = typeof NETPPM_STEP_IDS[keyof typeof NETPPM_STEP_IDS];

/**
 * Human-readable names for NetPPM workflow steps
 */
export const NETPPM_STEP_NAMES: Record<string, string> = {
  [NETPPM_STEP_IDS.GENERATE_PRUNED_VARIANCE_TREE]: 'Variance Tree Generation',
  [NETPPM_STEP_IDS.USER_TREE_SELECTION]: 'Variance Tree Node Selection',
  [NETPPM_STEP_IDS.GENERATE_COMMENTARY]: 'Commentary Generation',
};

/**
 * Factory functions for creating step inputs
 */
export const createNetPPMStepInput = {
  [NETPPM_STEP_IDS.GENERATE_PRUNED_VARIANCE_TREE]: () => null,
  
  [NETPPM_STEP_IDS.USER_TREE_SELECTION]: () => ({
    "message": "Please select the variance tree nodes for which you want to generate commentaries",
    "user_input_type": NETPPM_STEP_IDS.USER_TREE_SELECTION,
    "options": {
      "variance_tree": {
        "s3_uri": "${step.step_netppm_generate_pruned_variance_tree.output.pruned_variance_tree.s3_uri}"
      }
    }
  }),
  
  [NETPPM_STEP_IDS.GENERATE_COMMENTARY]: () => ({
    "tree_s3_location": "${step.step_netppm_user_tree_selection.output.user_input.selected_variance_tree!.s3_uri}",
    "tree_desc_s3_location": "${step.step_netppm_user_tree_selection.output.user_input.selected_variance_tree!.s3_uri}"
  }),
};
